import breakpoints from '../../styles/breakpoints.module.scss';

export const MobileSmallOrLarger = `@media (min-width: ${breakpoints.mobileSmall})`;
export const MobileOrLarger = `@media (min-width: ${breakpoints.mobile})`;
export const SmallOrLarger = `@media (min-width: ${breakpoints.small})`;
export const TabletOrLarger = `@media (min-width: ${breakpoints.tablet})`;
export const TabletHorizontalOrLarger = `@media (min-width: ${breakpoints.tablethori})`;
export const DesktopOrLarger = `@media (min-width: ${breakpoints.desktop})`;

export const MobileSmallOrSmaller = `@media (max-width: ${breakpoints.mobileSmall})`;
export const MobileOrSmaller = `@media (max-width: ${breakpoints.mobile})`;
export const SmallOrSmaller = `@media (max-width: ${breakpoints.small})`;
export const TabletOrSmaller = `@media (max-width: ${breakpoints.tablet})`;
export const TabletHorizontalOrSmaller = `@media (max-width: ${breakpoints.tablethori})`;
export const DesktopOrSmaller = `@media (max-width: ${breakpoints.desktop})`;
